import './WaitingSpinner.scss';
import clsx from 'clsx';

interface WaitingSpinnerType {
  active?: boolean;
  theme?: string;
  small?: boolean;
}

const CAPTION = 'Please wait...';

export const WaitingSpinner = (props: WaitingSpinnerType) => {
  return (
    <div
      className={clsx(
        'items-center flex bg-transparent text-[#e5c597] flex-col text-xs font-black justify-center h-full absolute opacity-0 left-0 top-0 w-full z-1 transition-opacity duration-300 select-none',
        props.active && 'opacity-100 pointer-events-auto',
      )}
    >
      <div className='flex items-center justify-center flex-col'>
        <div className={clsx('h-10 mx-auto my-0 mb-2.5 relative w-10', props.small && 'my-0 mx-auto w-8 h-8')}>
          <div className='absolute left-0 top-0 w-full h-full rounded-[40px] border border-[#e5c597]' />
          <div className='crown' />
        </div>
        {!props.small ? <div className='uppercase'>{CAPTION}</div> : null}
      </div>
    </div>
  );
};
